// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../config/api';

function QuizView({ topic, token }) {
    const [questions, setQuestions] = useState([]);
    const [userAnswers, setUserAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Reset when topic changes
    useEffect(() => {
        setQuestions([]);
        setUserAnswers({});
        setSubmitted(false);
        setError('');
    }, [topic]);

    const safeFetch = async (url, options) => {
        const res = await fetch(url, options);
        const text = await res.text();
        const trimmed = text ? text.trim() : '';
        if (!trimmed || trimmed === 'undefined') return { success: false, message: 'Empty response' };
        return JSON.parse(trimmed);
    };

    const generate = async () => {
        if (loading) return;
        setLoading(true);
        setQuestions([]);
        setUserAnswers({});
        setSubmitted(false);
        setError('');

        try {
            const data = await safeFetch(`${API_BASE_URL}/learnwithai/ai/quiz`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ topic, difficulty: 'medium' }),
            });

            if (data.success && data.data.questions.length > 0) {
                setQuestions(data.data.questions);
            } else {
                setError('Could not generate questions. Try again.');
            }
        } catch {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const selectAnswer = (qIdx, key) => {
        if (submitted) return;
        setUserAnswers(prev => ({ ...prev, [qIdx]: key }));
    };

    const submit = () => {
        if (Object.keys(userAnswers).length < questions.length) {
            setError('Please answer all questions before submitting.');
            return;
        }
        setError('');
        setSubmitted(true);
    };

    const score = submitted
        ? questions.filter((q, i) => userAnswers[i] === q.answer).length
        : 0;

    const getOptionClass = (qIdx, key) => {
        if (!submitted) {
            return userAnswers[qIdx] === key ? 'lw-option selected' : 'lw-option';
        }
        const correct = questions[qIdx].answer;
        if (key === correct) return 'lw-option correct';
        if (key === userAnswers[qIdx] && key !== correct) return 'lw-option wrong';
        return 'lw-option';
    };

    return (
        <div className="lw-quiz">
            <div className="lw-quiz-header">
                <span className="lw-quiz-title">
                    {questions.length > 0 ? `${questions.length} Questions — ${topic}` : `Quiz — ${topic}`}
                </span>
                <button
                    className="lw-btn-primary"
                    onClick={generate}
                    disabled={loading}
                >
                    {loading ? 'Generating…' : questions.length ? 'New Quiz' : 'Generate Quiz'}
                </button>
            </div>

            {error && <div className="lw-error">{error}</div>}

            {!questions.length && !loading && (
                <div className="lw-empty">
                    <span className="lw-empty-icon">🧠</span>
                    <p>Click <strong>Generate Quiz</strong> to get 3 MCQs on <strong>{topic}</strong></p>
                </div>
            )}

            {questions.map((q, qIdx) => (
                <div key={qIdx} className="lw-question-card">
                    <div className="lw-question-text">
                        {qIdx + 1}. {q.question}
                    </div>
                    <div className="lw-options">
                        {Object.entries(q.options).map(([key, val]) => (
                            <div
                                key={key}
                                className={getOptionClass(qIdx, key)}
                                onClick={() => selectAnswer(qIdx, key)}
                            >
                                <span className="lw-option-key">{key}.</span>
                                {val}
                            </div>
                        ))}
                    </div>
                </div>
            ))}

            {questions.length > 0 && !submitted && (
                <div className="lw-quiz-footer">
                    <button
                        className="lw-btn-primary"
                        onClick={submit}
                        disabled={Object.keys(userAnswers).length < questions.length}
                    >
                        Submit
                    </button>
                </div>
            )}

            {submitted && (
                <div className="lw-score">
                    Score: {score} / {questions.length}
                    {score === questions.length && ' 🎉 Perfect!'}
                    {score < questions.length && score >= Math.ceil(questions.length / 2) && ' 👍 Good job!'}
                    {score < Math.ceil(questions.length / 2) && ' 💪 Keep practicing!'}
                </div>
            )}
        </div>
    );
}

export default QuizView;
